











import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import BaseButton from "@/components/BaseButton";

@Component({ name: "PayeeInfoButton", components: { BaseButton } })
export default class PayeeInfoButton extends Vue {
  @Prop({ type: Boolean })
  public readonly isLastStep!: boolean;

  @Prop({ type: Boolean })
  public readonly disabled!: boolean;

  @Prop({ type: Boolean })
  public readonly loading!: boolean;
}
